
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind7 as ObiWind7Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-7.js';
 
 
 

 
 export const ObiWind7 = createComponent({
   react: React,
   tagName: 'obi-wind-7',
   elementClass: ObiWind7Element,
   events: {
     
   }
  });
 
 